import {t} from 'i18next';
import AurButton from '../../../common/aur-button/AurButton';
import {ReactComponent as BackArrow} from '../../../../assests/svg/back-icon-left.svg';
import {Typography} from '@mui/material';

interface Props {
  isHidden?: boolean;
  onClick: () => void;
}

const HeaderBackButton: React.FC<Props> = ({isHidden, onClick}) => {
  return (
    <AurButton
      onClick={onClick}
      type="text"
      size="Small"
      minWidth={0}
      classNames={`project-creation-header-back-button ${isHidden ? 'back-button-hidden' : ''}`}
    >
      <BackArrow aria-hidden={true} />
      <Typography className="typo-text buttonMedium_size back-button-text">
        {t('common.back')}
      </Typography>
    </AurButton>
  );
};

export default HeaderBackButton;
